import { useCallback, useEffect, useState } from "react";
import api from "../lib/api";

// Mandats légaux d'une fiche (lecture seule ici ; les écrans écrivent par leurs dialogues puis rechargent). `enabled` : le lecteur a le droit
// de lire les détails de la fiche, sinon le serveur répond 403 et on ne demande rien.
export default function useMandates(ficheId, enabled) {
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState(enabled ? "loading" : "idle"); // idle | loading | ready | error

  const reload = useCallback(async () => {
    if (!enabled) return;
    try {
      const { data } = await api.get(`/collaborators/${ficheId}/mandates`);
      setItems(data.items);
      setStatus("ready");
    } catch (e) {
      setStatus("error");
    }
  }, [ficheId, enabled]);

  // another fiche: never show the previous person's mandates while the new ones load
  useEffect(() => {
    setItems([]);
    setStatus("idle");
  }, [ficheId]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { items, status, reload };
}
